export const CONFIRM_REVENUE_KEY = 'jbp-partner-basic-info--revenue-confirm'

export const ConfirmRevenueDialogTranslations = {
  title: `${CONFIRM_REVENUE_KEY}--title`,
  titleRetail: `${CONFIRM_REVENUE_KEY}--title--retail`,

  message: `${CONFIRM_REVENUE_KEY}--message`,
  messageRetail: `${CONFIRM_REVENUE_KEY}--message--retail`,

  apply: `${CONFIRM_REVENUE_KEY}--apply`,
  cancel: `${CONFIRM_REVENUE_KEY}--cancel`,
}

export default ConfirmRevenueDialogTranslations
